import { useDispatch, API_PATH } from "./DataContext.js";
import Button from "react-bootstrap/Button";

export default function GroupCode (props)
{
    const gDispatch = useDispatch();

    let url = API_PATH + "#/play";
    if (props.code !== undefined) url += "?code="+props.code;

    if (props.fulllink !== undefined)
	return (<a href={url} target="_blank" rel="noreferrer" className="small">{url}</a>);

    else if (props.copylink !== undefined)
    {
	function handleClick ()
	{
	    navigator.clipboard.writeText(url);
	    gDispatch({ type: "alert", data: { variant: "success", title: "Lien copié dans votre presse-papiers", content: (<a href={url} target="_blank" rel="noreferrer">{url}</a>) }});
	}
	return (<Button size="sm" onClick={handleClick}>Copier le lien</Button>);
    }

    else {
	const code1 = props.code.substring(0,3);
	const code2 = props.code.substring(3,6);

	if (props.link !== undefined)
	{
	    
	    return (
		<a href={"#/play?code="+props.code} target="_blank" rel="noreferrer">
		    <span>{code1}</span><span>{code2}</span>
		</a>
	    );
	}

	else return (<span><span className="me-1">{code1}</span><span>{code2}</span></span>);
    }
}
